import Button from "@material-ui/core/Button";
import React, { useState, useEffect, useRef } from "react";
import Scheduler, { Resource } from "devextreme-react/scheduler";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import LinearProgress from "@material-ui/core/LinearProgress";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";
import { Typography } from "@material-ui/core";
import CreateIcon from "mdi-material-ui/CalendarPlus";
import ReminderIcon from "mdi-material-ui/BellRing";
import PublishIcon from "mdi-material-ui/CalendarMultipleCheck";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import moment from "moment";
import { withSnackbar } from "notistack";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import Fab from "@material-ui/core/Fab";
import Fade from "@material-ui/core/Fade";
import Plus from "mdi-material-ui/NotePlus";

import * as constants from "../../constants";
import * as actions from "../../store/actions";
import Confirmation from "../../components/Dialogs/Alert";
import CreateShiftDialog from "../../components/Dialogs/CreateShiftStepper";
import ShiftDetailsDialog from "../../components/Dialogs/ShiftDetails";
import TimeOffRequestDialog from "../../components/Dialogs/TimeOffRequest";
import ScheduleLegend from "../../components/ScheduleLegend";
import Header from "../../components/Typography/Header";
import {
  queryShifts,
  publishShifts,
  shiftReminders,
  queryShiftTemplates,
  deleteShift,
} from "../../utils/appsyncOperations";
import { isUserRole } from "../../utils/user";
import TabPanel from "../../components/TabPanel";
import ShiftTemplatesTable from "../../components/Tables/ShiftTemplates";
import CreateShiftTemplateDialog from "../../components/Dialogs/CreateTemplate";
import TemplateDetails from "../../components/Dialogs/TemplateDetails";
import ShiftCalendar from "../../components/Dialogs/ShiftCalendar";
import AppointmentTemplate from "../../components/Calendars/Appointments/ScheduleAppointment";

const views = ["timelineDay", "timelineMonth", "agenda"];
const groups = ["userId"];
const statusData = [
  {
    text: "Published",
    id: "PUBLISHED",
    color: "#cb6bb2",
  },
  {
    text: "Created",
    id: "CREATED",
    color: "#56ca85",
  },
  {
    text: "Acknowledged",
    id: "ACKNOWLEDGED",
    color: "#1e90ff",
  },
  {
    text: "Time off requested",
    id: "TIME_OFF_REQUESTED",
    color: "goldenrod",
  },
  {
    text: "Time off approved",
    id: "TIME_OFF_APPROVED",
    color: "#121212",
  },
  {
    text: "Coverage requested",
    id: "COVERAGE_REQUESTED",
    color: "goldenrod",
  },
  {
    text: "Coverage approved",
    id: "COVERAGE_APPROVED",
    color: "goldenrod",
  },
];

const styles = {
  menu: {
    width: 200,
  },
  progress: {
    height: 4,
  },
};

const calHeaderHeight = 100;
const tabValues = {
  shifts: {
    value: "shifts",
  },
  templates: {
    value: "templates",
  },
};

const ScheduleContent = ({
  divisions,
  serviceProviderId,
  shifts,
  users,
  enqueueSnackbar,
  dispatch,
  history,
  location,
  match,
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [divisionId, setDivisionId] = useState("");
  const [date, setDate] = useState(() => new Date());
  const [view, setView] = useState("timelineMonth");
  const [shiftLoading, setShiftLoading] = useState(false);
  const [data, setData] = useState([]);
  const [height, setHeight] = useState(calHeaderHeight);
  const [userData, setUserData] = useState([]);
  const [speedDialIsOpen, setSpeedDialIsOpen] = useState(true);
  const [showPublishConfirmation, setShowPublishConfirmation] = useState(false);
  const [showReminderConfirmation, setShowReminderConfirmation] = useState(
    false
  );
  const [unpublishedShifts, setUnpublishedShifts] = useState([]);
  const [unackShifts, setUnackShifts] = useState([]);
  const [fabExiting, setFabExiting] = useState(false);
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);
  const [tab, setTab] = useState(tabValues.shifts.value);
  const scheduleRef = useRef(null);

  useEffect(() => {
    setHeight(userData.length * 150 + calHeaderHeight);
  }, [userData]);

  useEffect(() => {
    const init = async () => {
      try {
        const templates = await queryShiftTemplates(serviceProviderId);
        dispatch(actions.templates.initTemplates(templates));
      } catch (e) {
        console.error(e);
        enqueueSnackbar(e, { variant: "error" });
      }
    };
    init();
  }, []);

  useEffect(() => {
    const formattedData = Object.values(shifts)
      .filter((shift) => shift.divisionId === divisionId)
      .map((shift) => {
        const { userId, startTime, endTime, status, shiftId, timezone } = shift;
        let id, text;
        if (!userId) {
          id = "OPEN";
          text = "Open Shift";
        } else {
          id = userId;
          text = users[userId].displayName;
        }
        return {
          text,
          userId: id,
          startDate: new Date(startTime),
          endDate: new Date(endTime),
          status,
          shiftId,
          timezone,
        };
      });
    setData(formattedData);
  }, [shifts, divisionId]);

  useEffect(() => {
    if (!divisionId) setUserData([]);
    else {
      const division = divisions[divisionId];
      const formattedData = Object.keys(division.users.byId)
        .filter((userId) => !division.users.byId[userId].isDeleted)
        .map((userId) => ({ text: users[userId].displayName, id: userId }))
        .sort((a, b) => a.text.localeCompare(b.text));
      const openShifts = {
        text: "Open Shifts",
        id: "OPEN",
      };
      setUserData([openShifts, ...formattedData]);
    }
  }, [divisionId]);

  useEffect(() => {
    getShifts();
  }, [date, view]);
  const getShifts = async () => {
    setShiftLoading(true);
    let startMoment, endMoment;
    switch (view) {
      case "timelineDay":
        startMoment = moment(date).startOf("day");
        endMoment = moment(date).endOf("day");
        break;
      case "timelineWeek":
        startMoment = moment(date).startOf("week");
        endMoment = moment(date).endOf("week");
        break;
      case "timelineMonth":
        startMoment = moment(date).startOf("month");
        endMoment = moment(date).endOf("month");
        break;
      case "agenda":
        startMoment = moment(date).startOf("day");
        endMoment = moment(date).add(6, "days").endOf("day");
        break;
    }
    const to = endMoment.valueOf();
    const from = startMoment.valueOf();
    try {
      const shiftsRes = await queryShifts({ serviceProviderId, from, to });
      dispatch(actions.shifts.initShifts(shiftsRes));
    } catch (e) {
      console.error(e);
      enqueueSnackbar(e, { variant: "error" });
    }
    setShiftLoading(false);
  };

  const selectedShift = shifts[match.params.scheduleId];
  let shiftDialogType;
  if (
    selectedShift === undefined ||
    (selectedShift.status !== constants.shift.status.timeOffRequested.value &&
      selectedShift.status !== constants.shift.status.timeOffApproved.value)
  ) {
    shiftDialogType = "DETAILS";
  } else {
    shiftDialogType = "TIME_OFF";
  }

  const onOptionChanged = (event) => {
    switch (event.fullName) {
      case "currentView":
        setView(event.value);
        break;
      case "currentDate":
        setDate(event.value);
        break;
    }
  };

  const scrollToNow = () => {
    const now = moment();
    if (scheduleRef.current) {
      scheduleRef.current.instance.scrollToTime(
        now.hours(),
        now.minutes(),
        now.toDate()
      );
    }
  };

  const handleCellClick = (data) => {
    if (isUserRole({ admin: true })) {
      const current = moment();
      const start = moment(data.startDate);
      const userId = data.groups.userId;
      if (start.valueOf() < current.valueOf()) {
        return enqueueSnackbar("You can only create shifts in the future.", {
          variant: "error",
        });
      }

      if (userId === "OPEN") {
        return history.push(
          `/schedules/create?start=${start.valueOf()}&end=${start
            .endOf("day")
            .valueOf()}`
        );
      } else {
        return history.push(
          `/schedules/create?start=${start.valueOf()}&end=${start
            .endOf("day")
            .valueOf()}&user=${userId}`
        );
      }
    }
  };

  let createShiftParams;
  if (location.pathname === "/schedules/create") {
    createShiftParams = queryString.parse(location.search);
  }

  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <div className={classes.scrollable}>
          <Paper className={classes.paper}>
            <Grid container spacing={3}>
              <Grid item s={12} xs={12}>
                <Header label={"Schedules"} />
              </Grid>
              <Grid item s={12} xs={12}>
                <Tabs
                  indicatorColor="primary"
                  centered
                  value={tab}
                  onChange={(event, newValue) => setTab(newValue)}
                >
                  <Tab label="Shifts" value={tabValues.shifts.value} />
                  <Tab label="Templates" value={tabValues.templates.value} />
                </Tabs>
              </Grid>
              <TabPanel value={tabValues.templates.value} index={tab}>
                <Grid item s={12} xs={12}>
                  <ShiftTemplatesTable
                    onViewClick={(templateId) =>
                      setSelectedTemplate(templateId)
                    }
                  />
                </Grid>
              </TabPanel>
              <TabPanel value={tabValues.shifts.value} index={tab}>
                <Grid item s={12} xs={12}>
                  <TextField
                    select
                    label="Division"
                    value={divisionId}
                    onChange={(e) => setDivisionId(e.target.value)}
                    SelectProps={{
                      MenuProps: {
                        style: styles.menus,
                      },
                    }}
                    fullWidth
                    variant="outlined"
                  >
                    {Object.values(divisions)
                      .filter((division) => !division.isDeleted)
                      .map((item) => (
                        <MenuItem key={item.divisionId} value={item.divisionId}>
                          {item.displayName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                {divisionId !== "" && (
                  <>
                    <Grid item xs={12}>
                      <ScheduleLegend itemSize={4} />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setShowCalendar(true)}
                      >
                        Calendar
                      </Button>
                      <Button
                        onClick={getShifts}
                        className={classes.reloadButton}
                        color="primary"
                      >
                        Reload
                      </Button>
                    </Grid>
                  </>
                )}
                <Grid item xs={12}>
                  {shiftLoading ? (
                    <LinearProgress style={styles.progress} />
                  ) : (
                    <div style={styles.progress} />
                  )}
                </Grid>
                <Grid item s={12} xs={12}>
                  {divisionId === "" ? (
                    <Typography variant="body1">Select a division.</Typography>
                  ) : (
                    <>
                      <Scheduler
                        ref={scheduleRef}
                        appointmentRender={AppointmentTemplate}
                        dataSource={data}
                        onContentReady={scrollToNow}
                        views={views}
                        currentView={view}
                        currentDate={date}
                        height={height}
                        shadeUntilCurrentTime
                        groups={groups}
                        firstDayOfWeek={0}
                        startDayHour={0}
                        maxAppointmentsPerCell="auto"
                        endDayHour={24}
                        editing={{
                          allowAdding: false,
                          allowDeleting: false,
                          allowDragging: false,
                          allowResizing: false,
                          allowUpdating: false,
                        }}
                        onAppointmentClick={(e) => {
                          history.push(
                            `/schedules/${e.appointmentData.shiftId}`
                          );
                          return (e.cancel = true);
                        }}
                        onCellClick={(e) => handleCellClick(e.cellData)}
                        onAppointmentDblClick={(e) => (e.cancel = true)}
                        onOptionChanged={onOptionChanged}
                      >
                        <Resource
                          fieldExpr={"status"}
                          allowMultiple={true}
                          dataSource={statusData}
                          label={"Status"}
                          useColorAsDefault={true}
                        />
                        <Resource
                          fieldExpr={"userId"}
                          allowMultiple={false}
                          dataSource={userData}
                          label={"Name"}
                        />
                      </Scheduler>
                    </>
                  )}
                </Grid>
              </TabPanel>
            </Grid>
          </Paper>
        </div>
        {isUserRole({ admin: true }) && (
          <>
            <Fade
              in={
                divisionId !== "" &&
                tab === tabValues.shifts.value &&
                !fabExiting
              }
              onExiting={() => setFabExiting(true)}
              onExited={() => setFabExiting(false)}
            >
              <SpeedDial
                open={speedDialIsOpen}
                onClick={() => setSpeedDialIsOpen(!speedDialIsOpen)}
                onClose={() => setSpeedDialIsOpen(false)}
                ariaLabel="Scheduling Options"
                className={classes.speedDial}
                icon={<SpeedDialIcon />}
              >
                <SpeedDialAction
                  key={"createShift"}
                  icon={<CreateIcon />}
                  tooltipTitle={
                    <span className={classes.tooltipTitle}>Create Shift</span>
                  }
                  tooltipOpen
                  onClick={() => history.push("schedules/create")}
                />
                <SpeedDialAction
                  key={"shiftReminders"}
                  icon={<ReminderIcon />}
                  tooltipTitle={
                    <span className={classes.tooltipTitle}>Send Reminders</span>
                  }
                  tooltipOpen
                  onClick={() => {
                    const unackShifts = data.filter(
                      (shift) =>
                        shift.status === "PUBLISHED" &&
                        shift.startDate.getTime() > Date.now() &&
                        shift.userId !== "OPEN"
                    );
                    if (unackShifts.length > 0) {
                      setUnackShifts(unackShifts);
                      setShowReminderConfirmation(true);
                    } else {
                      enqueueSnackbar("No shifts need to be acknowledged.");
                    }
                  }}
                />
                <SpeedDialAction
                  key={"publishShifts"}
                  icon={<PublishIcon />}
                  tooltipTitle={
                    <span className={classes.tooltipTitle}>Publish Shift</span>
                  }
                  tooltipOpen
                  onClick={() => {
                    const unpubShifts = data.filter(
                      (shift) =>
                        shift.status === "CREATED" &&
                        shift.startDate.getTime() > Date.now()
                    );
                    if (unpubShifts.length > 0) {
                      setUnpublishedShifts(unpubShifts);
                      setShowPublishConfirmation(true);
                    } else {
                      enqueueSnackbar("No shifts need to be published.");
                    }
                  }}
                />
              </SpeedDial>
            </Fade>
            {
              <Fade
                in={tab === tabValues.templates.value && !fabExiting}
                onExiting={() => setFabExiting(true)}
                onExited={() => setFabExiting(false)}
              >
                <Fab
                  color="primary"
                  className={classes.fab}
                  onClick={() => setShowCreateTemplate(true)}
                >
                  <Plus />
                </Fab>
              </Fade>
            }
          </>
        )}
      </div>
      <CreateShiftTemplateDialog
        open={showCreateTemplate}
        onClose={() => setShowCreateTemplate(false)}
      />
      {isUserRole({ admin: true }) && match.path === "/schedules/create" && (
        <CreateShiftDialog
          isOpen={match.path === "/schedules/create"}
          onClose={() => history.push("/schedules")}
          divisionId={divisionId}
        />
      )}
      {showCalendar && (
        <ShiftCalendar
          divisionId={divisionId}
          isOpen={showCalendar}
          onClose={() => setShowCalendar(false)}
        />
      )}

      <TemplateDetails
        open={selectedTemplate !== null}
        onClose={() => setSelectedTemplate(null)}
        templateId={selectedTemplate}
      />
      {shiftDialogType !== "TIME_OFF" ? (
        <ShiftDetailsDialog
          onSave={(savedShift) => dispatch(actions.shifts.setShift(savedShift))}
          onPublish={(publishedShift) => {
            dispatch(actions.shifts.setShift(publishedShift));
            history.push("/schedules");
          }}
          onDelete={(deletedShift) => {
            dispatch(
              actions.shifts.initShifts(
                Object.values(shifts).filter(
                  (shift) => shift.shiftId !== deletedShift.shiftId
                )
              )
            );
            history.push("/schedules");
          }}
          onCoverageApproved={(approvedShift) => {
            dispatch(actions.shifts.setShift(approvedShift));
            history.push("/schedules");
          }}
          onCoverageDenied={(deniedShift) => {
            dispatch(actions.shifts.setShift(deniedShift));
            history.push("/schedules");
          }}
          shift={selectedShift}
          open={selectedShift}
          onClose={() => history.push("/schedules")}
          divisionId={divisionId}
        />
      ) : (
        <TimeOffRequestDialog
          shift={selectedShift}
          open={selectedShift}
          onApproved={(approvedShift) => {
            dispatch(actions.shifts.setShift(approvedShift));
            history.push("/schedules");
          }}
          onDenied={(deniedShift) => {
            dispatch(
              actions.shifts.initShifts(
                Object.values(shifts).filter(
                  (shift) => shift.shiftId !== deniedShift.shiftId
                )
              )
            );
            history.push("/schedules");
          }}
          onDeletion={(deletedShift) => {
            dispatch(
              actions.shifts.initShifts(
                Object.values(shifts).filter(
                  (shift) => shift.shiftId !== deletedShift.shiftId
                )
              )
            );
            history.push("/schedules");
          }}
          onClose={() => history.push("/schedules")}
        />
      )}
      <Confirmation
        isOpen={showPublishConfirmation}
        onClose={() => setShowPublishConfirmation(false)}
        title={`Publish ${unpublishedShifts.length} Drafts`}
        onNo={() => setShowPublishConfirmation(false)}
        content={`Are you sure you want to publish ${unpublishedShifts.length} drafts? Notifications will be sent out.`}
        onYes={async () => {
          setShiftLoading(true);
          setShowPublishConfirmation(false);
          try {
            const shifts = await publishShifts(
              unpublishedShifts.map((shift) => shift.shiftId)
            );
            dispatch(actions.shifts.setShifts(shifts));
            enqueueSnackbar("Publish successful", { variant: "success" });
          } catch (e) {
            enqueueSnackbar(e, { variant: "error" });
            console.error(e);
          }
          setShiftLoading(false);
        }}
      />
      <Confirmation
        isOpen={showReminderConfirmation}
        onClose={() => setShowReminderConfirmation(false)}
        title={`Send ${unackShifts.length} Reminders`}
        onNo={() => setShowReminderConfirmation(false)}
        content={`Are you sure you want to send ${unackShifts.length} reminders? Notifications will be sent out.`}
        onYes={async () => {
          setShiftLoading(true);
          setShowReminderConfirmation(false);
          try {
            const shifts = await shiftReminders(
              unackShifts.map((shift) => shift.shiftId)
            );
            dispatch(actions.shifts.setShifts(shifts));
            enqueueSnackbar("Reminders sent!", { variant: "success" });
          } catch (e) {
            enqueueSnackbar(e, { variant: "error" });
            console.error(e);
          }
          setShiftLoading(false);
        }}
      />
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    position: "relative",
  },
  scrollable: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    overflowX: "hidden",
    overflowY: "auto",
  },
  paper: {
    margin: theme.spacing(3),
    padding: theme.spacing(3),
  },
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  speedDial: {
    position: "absolute",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-direction-Right": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
  tooltipTitle: {
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  reloadButton: {
    marginLeft: 8,
  },
}));

const mapStateToProps = (state) => ({
  divisions: state.divisions.byId,
  serviceProviderId: state.auth.user.attributes["custom:service_provider_id"],
  users: state.users.byId,
  shifts: state.shifts.byId,
  templates: state.templates.byId,
});

export default withRouter(
  withSnackbar(connect(mapStateToProps)(ScheduleContent))
);
